import FormConfig from './form.vue';

export default FormConfig;
